var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{attrs:{"indeterminate":true,"rotate":360,"size":_vm.calcSize,"value":_vm.value,"width":_vm.width,"color":_vm.color}},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }